<template>
    <div class="client-lict">
        <div class="header">
            <div class="text">客户机会</div>
        </div>
        <!-- 搜索部分 -->
        <div class="search-box">
            <veui-form
                :data="formData"
                @submit="handleSubmit"
            >
                <veui-field
                    label="客户姓名"
                    class="name m"
                >
                    <veui-input
                        v-model="formData.name"
                        placeholder="请输入姓名"
                    />
                </veui-field>
                <veui-field
                    label="城市"
                    class="city m"
                >
                    <veui-input
                        v-model="formData.city"
                        placeholder="请输入城市"
                    />
                </veui-field>
                <veui-field label="创建时间" class="join-date m">
                    <veui-date-picker
                        v-model="formData.date"
                        range
                        clearable
                        class="join-date-picker"
                        overlay-class="join-date-picker-popup"
                    />
                </veui-field>
                <template #actions>
                    <veui-button ui="strong" @click="resetForm">重置</veui-button>
                    <veui-button ui="primary" type="submit">查询</veui-button>
                </template>
            </veui-form>
        </div>
        <veui-table
            :data="tableData"
            role="columnheader"
            :loading="isLoading"
            :order="order"
            :order-by="orderBy"
            @sort="handleSort"
        >
            <veui-table-column
                field="name"
                title="客户姓名"
                width="140"
            >
                <template #default="{name}">
                    <div ref="name" class="name">{{ name || '-' }}</div>
                    <veui-tooltip
                        target="name"
                        :hide-delay="100"
                    >
                        {{ name }}
                    </veui-tooltip>
                </template>
            </veui-table-column>
            <veui-table-column
                field="city"
                title="城市"
                width="100"
            >
                <template #default="{city}">
                    {{ city || '-' }}
                </template>
            </veui-table-column>
            <veui-table-column
                field="phone"
                title="手机号"
                width="110"
            >
                <template #default="{phone}">
                    {{ phone || '-' }}
                </template>
            </veui-table-column>
            <veui-table-column
                field="create_time"
                width="110"
                sortable
            >
                <template #head>
                    <div class="title-head">
                        创建时间
                    </div>
                </template>
                <template #default="{create_time}">
                    {{ create_time | dateFilter }}
                </template>
            </veui-table-column>
            <veui-table-column
                field="operation"
                title="操作"
                width="110"
            >
                <template #default="{index}">
                    <div>
                        <veui-button
                            ui="text"
                            @click="add(index)"
                        >
                            添加潜客
                        </veui-button>
                    </div>
                </template>
            </veui-table-column>
        </veui-table>
        <!-- 分页 -->
        <veui-pagination
            v-if="tableData && tableData.length"
            :page="pn"
            :page-size="rn"
            :total="count"
            class="pagination"
            @redirect="pageChange"
        />
        <add-drawer
            v-if="openAddDrawer"
            :open="openAddDrawer"
            :client-data="detailData"
            :fid="fid"
            @closeDrawer="closeDrawer"
        />
    </div>
</template>

<script>
// 客户机会列表
import {
    Input,
    Form,
    Field,
    Button,
    Table,
    Column,
    Pagination,
    DatePicker,
    Tooltip
} from 'veui';
import {mapState} from 'vuex';
import addDrawer from './components/add-drawer.vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
export default {
    name: 'ClientChanceList',
    components: {
        'veui-input': Input,
        'veui-form': Form,
        'veui-field': Field,
        'veui-button': Button,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-date-picker': DatePicker,
        'add-drawer': addDrawer,
        'veui-tooltip': Tooltip
    },
    filters: {
        dateFilter(date) {
            if (!date) {
                return '-';
            }
            dayjs.extend(utc);
            return dayjs.utc(date).format('YYYY-MM-DD');
        }
    },
    data() {
        return {
            formData: {
                name: '',
                city: '',
                date: null
            },
            tableData: [],
            rn: 10,
            pn: 1,
            // 详情数据
            detailData: {},
            isLoading: false,
            openAddDrawer: false,
            // 机构id
            fid: '',
            // 总数
            count: 0,
            // 创建时间排序：desc:降序，asc:升序
            order: 'desc',
            // 用于指定当前基于哪一列进行了排序，值必须来自内部某个 Column 组件的 field 属性
            orderBy: ''
        };
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew,
            law_firm_info: state => state.lawStore.userInfoNew.law_firm_info
                || state.lawStore.userInfoNew.law_firm_subaccount || {}
        })
    },
    watch: {
        userInfoNew: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                let firm_info = newVal?.law_firm_info || newVal?.law_firm_subaccount || {};
                this.fid = firm_info?.id ? firm_info.id + '' : '';
            }
        }
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        /**
         * 提交查询
         * @param {Object} data 表单信息
         */

        handleSubmit() {
            this.pageChange(1);
        },

        /**
         * 重置
         */

        resetForm() {
            this.formData = {
                name: '',
                city: '',
                date: null
            };
            this.handleSubmit();
        },

        /**
         * 获取表格数据
         */

        getTableData() {
            this.isLoading = true;
            let params = {
                ...this.formatFormData(),
                pn: this.pn,
                rn: this.rn
            };
            this.$http.get('/bp/crm/crmleadslist', {
                params
            }).then(res => {
                if (!res || +res.code !== 0 || !res.data) {
                    this.tableData = [];
                    return;
                }
                this.tableData = res?.data?.list || [];
                this.count = res?.data?.count || 0;
            }).finally(() => {
                this.isLoading = false;
            });
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.pn = pn;
            this.getTableData();
        },

        /**
         * 处理搜索参数
         */

        formatFormData() {
            let {
                city,
                name,
                date
            } = this.formData || {};
            let [startDate, endDate] = date || [];
            startDate = startDate ? dayjs(startDate)?.unix() : '';
            endDate = endDate ? dayjs(endDate)?.hour(23).minute(59).second(59).unix() : '';
            let params = {
                name,
                city,
                create_time_range: startDate && endDate ? startDate + ',' + endDate : '',
                create_time_sort: this.order || '' // desc:降序，asc:升序
            };
            return params;
        },

        /**
         * 添加潜客
         */

        add(index) {
            this.openAddDrawer = true;
            this.detailData = this.tableData[index] || {};
        },
        closeDrawer() {
            this.openAddDrawer = false;
            this.pageChange(1);
        },

        /**
         * 排序时触发
         * @param {String} field 对哪一列排序
         * @param {String} order 排序顺序
         */

        handleSort(field, order) {
            this.orderBy = field;
            this.order = order;
            this.pageChange(1);
        }
    }
};
</script>

<style scoped lang="less">
@import "../../assets/css/law-table.less";
@inputWidth:150px;
@inputWidthLarge:255px;

.client-lict {
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
    padding: 32px 30px 20px;

    .header {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        position: relative;

        .text {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000;
            line-height: 18px;
        }
    }

    .search-box {
        .veui-form {
            display: flex;
            flex-wrap: wrap;
            position: relative;

            .veui-button {
                height: 40px;
                width: 80px;
                font-size: 16px;
                border-radius: 5px;
            }
        }

        .certificate-no,
        .name,
        .type,
        .city,
        .wish,
        .clue-from,
        .join-date,
        .custome-type {
            margin-right: 30px;
        }

        /deep/.veui-field.l {
            .veui-input {
                width: @inputWidthLarge;
            }

            .option {
                width: @inputWidthLarge;
            }
        }

        /deep/.veui-field {
            margin-bottom: 18px;
            height: 40px;

            .veui-field-label {
                margin-right: 0;
                width: 80px;
                line-height: 40px;
                height: 40px;
                justify-content: flex-start;
            }
        }

        /deep/.veui-form-actions {
            margin-top: 0;
            padding-left: 0;

            .veui-button {
                margin-left: 0;

                &:last-child {
                    margin-left: 10px;
                }
            }
        }

        .veui-input {
            width: @inputWidth;
            height: 40px;
            border: 1px solid #e9ecf3;
            border-radius: 8px;

            &.veui-focus,
            &:hover {
                border: 1px solid #3855d5;
                box-shadow: none;
            }
        }

        .veui-select.veui-select-expanded {
            border: 1px solid #3855d5;
        }

        /deep/.option {
            width: @inputWidth;
            height: 40px;
            display: inline-flex;
            // margin-left: 20px;
            border: 1px solid #e9ecf3;
            border-radius: 8px;

            .veui-input {
                border: none;
            }

            &:focus,
            &:hover,
            &.veui-select-expanded {
                border: 1px solid #3855d5;
            }
        }

        .city-option {
            /deep/.ivu-input {
                width: @inputWidth;
            }
        }
    }

    .veui-table {
        margin-top: 24px;

        .title-head {
            display: flex;
            cursor: pointer;

            .icon {
                height: 14px;
                width: 14px;
                margin-left: 2px;
            }
        }

        .veui-table-cell-content {
            .veui-button {
                color: #05f;
            }

            .name {
                max-width: 230px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
        }

        .veui-table-cell-content .label {
            &.green {
                color: #17b42f;
            }

            &.blue {
                color: #3855d5;
            }
        }
    }
}

.join-date-picker {
    width: 260px;

    /deep/.veui-date-picker-trigger {
        height: 40px;
        border-radius: 8px;
        border: 1px solid #e9ecf3;

        &::hover {
            border: 4px solid #3855d5;
        }
    }
}

/deep/.veui-date-picker-trigger:hover {
    border: 1px solid #3855d5 !important;
}

.pagination {
    float: right;
    padding: 30px 0;
}
</style>